<template>
  <div class="imageSlider" :style="{ height: boxHeight }">
    <div
      v-for="(item, index) in items"
      :key="item.id"
      :style="{
        'background-image': `url('${item.image}')`,
      }"
      :class="{ active: index === activeIndex }"
      class="backgroundImageLayer"
    ></div>
    <div class="titleBox">
      <h1 ref="title" :class="{ animate: isTitleAnimating && animateTitle }">
        {{ item.title }}
      </h1>
      <p v-if="linkText" class="mt-3">
        <a :href="item.link">{{ linkText }}</a>
      </p>
    </div>
    <div class="imgNav">
      <span
        v-for="(item, index) in items.slice(0, 3)"
        :id="item.id"
        :key="item.id"
        :class="{ active: index === activeIndex }"
        @click="setActiveIndex(index)"
      ></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageSlider",
  props: {
    items: {
      type: Array,
      required: true,
    },
    linkText: {
      type: String,
      default: "",
    },
    boxHeight: {
      type: String,
      default: "75vh", // Fallback-Höhe
    },
    animateTitle: {
      type: Boolean,
      default: true, // Standardmäßig true, Animation ist aktiv
    },
  },
  data() {
    return {
      activeIndex: 0,
      intervalId: null,
      isTitleAnimating: false,
    };
  },
  computed: {
    item() {
      return this.items[this.activeIndex] || {};
    },
  },
  mounted() {
    this.startRotation();
    this.setInitialActive();
  },
  methods: {
    startRotation() {
      this.intervalId = setInterval(() => {
        this.activeIndex =
          (this.activeIndex + 1) % this.items.slice(0, 3).length;
        this.animateTitleIfNeeded();
      }, 5000);
    },
    setActiveIndex(index) {
      this.activeIndex = index;
      clearInterval(this.intervalId);
      this.startRotation();
      this.animateTitleIfNeeded();
    },
    setInitialActive() {
      setTimeout(() => {
        this.activeIndex = 0;
        this.animateTitleIfNeeded();
      }, 0);
    },
    animateTitleIfNeeded() {
      if (this.animateTitle) {
        this.isTitleAnimating = false;
        setTimeout(() => {
          this.isTitleAnimating = true;
          setTimeout(() => {
            this.isTitleAnimating = false;
          }, 500); // Dauer der Animation
        }, 10);
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style scoped lang="sass">
@import '@/assets/sass/main.sass'
.imageSlider
  position: relative
  width: 80%
  margin: 0 10% 4vh 10%
  overflow: hidden
  background-color: black
  @media (max-width: $breakPointLG)
    width: 100%
    margin: 0 0 4vh 0
  .backgroundImageLayer
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-size: cover
    background-position: center center
    background-repeat: no-repeat
    transition: opacity 1s ease-in-out, transform 5s ease-in-out
    opacity: 0
    transform: scale(1.2)
    &.active
      opacity: 1
      transform: scale(1)
  .imgNav
    width: auto
    position: absolute
    bottom: -2px
    left: 50%
    transform: translateX(-50%)
    text-align: center
    span
      content: ''
      background-color: white
      height: 9px
      width: 30vw
      max-width: 90px
      display: inline-block
      margin: 0 3px 5px 3px
      position: relative
      overflow: hidden
      @media (max-width: $breakPointLG)
        width: 25vw
        max-width: 60px
      &:before
        content: ''
        position: absolute
        top: 0
        left: 0
        height: 100%
        width: 0
        background-color: $gold
        transition: none
      &.active:before
        transition: width 5s linear
        width: 100%
  .titleBox
    position: absolute
    bottom: 0
    left: 50%
    transform: translateX(-50%)
    background-image: linear-gradient(to top, black, transparent, transparent)
    color: white
    width: 100%
    height: 100%
    display: flex
    flex-direction: column
    align-items: center
    justify-content: flex-end
    padding: 4rem 5vw
    text-transform: uppercase
    h1
      text-align: center
      transition: all 0.5s ease-in-out
      padding: 1rem 2rem
      margin-bottom: -1rem
      &.animate
        transform: scale(1.1)
        box-shadow: 0 0 25px 0 rgba(black, .4)
        background-color: rgba(black, .2)
        border-radius: 20%
    p
      border-top: 1px solid white
      padding-top: 1rem
      a
        transition: .8s
        text-decoration: none
        color: white
        display: block
        padding: 0 5vw
        &:hover
          transform: scale(1.2)
          color: $gold
</style>
